export default __webpack_public_path__ + "static/media/academic_hourse.ebd7f92b.svg";